import React from 'react'
import { ifStringEmpty, handleIE } from '../../../actions/static'
import { SendIcon } from '../../../icons/Icons'
import PersistentMenu from '../../persistentMenu/PersistentMenu'
import AttachmentUploadButton from '../AttachmentFiles/AttachmentUploadButton/AttachmentUploadButton'
import { enableFileUploading } from '../../../app/config'

import classes from './styles.module.scss'

class ChatInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      text: '',
    }
  }

  sendText = () => {
    const { text } = this.state
    if (!ifStringEmpty(text)) {
      const message = {
        from: {
          id: this.props.chatId,
          name: this.props.startData.name || 'Widget user',
          email: this.props.startData.email || '',
        },
        type: 'text',
        isRtl: this.props.isRtl,
        text,
      }
      this.setState(
        {
          text: '',
        },
        () => {
          this.props.postMessage(message)
        },
      )
    }
  }

  handleChange(value) {
    this.setState({
      text: value,
    })
  }

  handleEnterPress = e => {
    if (e.charCode === 13) {
      this.sendText()
    }
  }

  render() {
    const {
      textDisabled,
      settings,
      persistentMenu,
      isFullScreenWidget,
      isRtl,
      chatId,
      device,
      botId,
      openIframe,
      showIframe
    } = this.props
    const { text } = this.state
    const isIE = handleIE()
    const direction = isRtl ? 'rtl' : 'ltr'
    return (
      <div className={textDisabled ? classes.wrapInput : classes.hideInput}>
        <PersistentMenu
          botId={botId}
          device={device}
          isFullScreenWidget={isFullScreenWidget}
          chatId={chatId}
          settings={settings}
          persistentMenu={persistentMenu}
          openIframe={openIframe}
          showIframe={showIframe}
          postMessage={message => this.props.postMessage(message)}
        />
        <input
          placeholder={settings.inputPlaceholder}
          className={classes.input}
          style={{ direction }}
          type="text"
          value={text}
          onKeyPress={e => {
            if (e.charCode === 13) {
              this.sendText()
            }
          }}
          dir={direction}
          id='messaging-user-input'
          onChange={e => this.handleChange(e.target.value)}
        />
        {enableFileUploading && <AttachmentUploadButton />}
        <div onClick={this.sendText} className={classes.svgHolder}>
          <SendIcon
            width={isIE ? 40 : 21}
            heigth={isIE ? 40 : 21}
            color={settings.color}
          />
        </div>
      </div>
    )
  }
}

export default ChatInput
